import cn from "classnames";
import { FC, useState, InputHTMLAttributes } from "react";
import styles from "./MyInput.module.sass";
import { ReactComponent as PasswordHidden } from "images/PasswordHidden.svg";
import { ReactComponent as PasswordShown } from "images/PasswordShown.svg";

interface MyInputProps extends InputHTMLAttributes<HTMLInputElement> {
	name: string;
	placeholder: string;
	value: string;
	set: (e: any) => void;
	required?: boolean;
	condition?: boolean;
	type?: string;
	maxLength?: number;
	width?: string;
	warning?: { text: string; condition: boolean };
	description?: string;
	blur?: () => void;
	readOnly?: boolean;
}

export const MyInput: FC<MyInputProps> = ({
	className,
	name,
	placeholder,
	value,
	set,
	required,
	condition,
	type = "string",
	maxLength,
	width,
	warning,
	description,
	blur,
	readOnly,
}) => {
	const [isFocus, setIsFocus] = useState<boolean>(false);
	const [passwordShown, setPasswordShown] = useState<Boolean>(false);

	const onBlurHandler = () => {
		setIsFocus(false);
		if (blur) blur();
	};

	return (
		<>
			<div className={cn(styles.wrp, className, styles[`${width}`])}>
				<div className={styles["name-wrp"]}>
					<span className={cn(`${isFocus ? styles["name-focus"] : styles.name}`, condition ? "error-input-title" : "")}>
						{name}
						{required && <span className="red"> *</span>}
					</span>
					{warning?.condition && <span className={styles["name-warning"]}>{warning?.text}</span>}
				</div>
				<div className={styles["input-wrp"]}>
					<input
						type={type === "password" && !passwordShown ? "password" : "string"}
						value={value}
						onChange={set}
						onFocus={() => setIsFocus(true)}
						onBlur={onBlurHandler}
						className={cn(
							styles.input,
							condition ? "error-input" : "",
							type === "password" ? styles["input-padding"] : "",
						)}
						maxLength={maxLength}
						placeholder={placeholder}
						readOnly={readOnly}
					/>
					{!value && maxLength && <span className={styles.limit}>до {maxLength} символов</span>}
					{type === "password" && (
						<button onClick={() => setPasswordShown((prev) => !prev)} type="button" className={styles.toggler}>
							{passwordShown ? <PasswordShown /> : <PasswordHidden />}
						</button>
					)}
				</div>
			</div>
			{description && <p className={cn(styles.description, condition ? "error-input-title" : "")}>{description}</p>}
		</>
	);
};
